export default "__VITE_ASSET__f0c9d758__"